/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './media-detector.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../app/media-detector/media-detector.component';
import * as i3 from '@ngrx/store/src/store';
import * as i4 from '@nw/ui-core-shared/store/actions/app-ui.action';
import * as i5 from '@angular/platform-browser';
import * as i6 from '@nw/ui-core-shared/services/utility.service';
const styles_MediaDetectorComponent:any[] = [i0.styles];
export const RenderType_MediaDetectorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MediaDetectorComponent,data:{}});
export function View_MediaDetectorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{detector:0}),(_l()(),i1.ɵeld(1,0,[[1,0],['detector',
      1]],(null as any),0,'span',[['class','media-detector']],(null as any),[['window',
      'resize']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.MediaDetectorComponent = _v.component;
    if (('window:resize' === en)) {
      const pd_0:any = ((<any>_co.onResize()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),
      (null as any));
}
export function View_MediaDetectorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'nw-media-detector',
      ([] as any[]),(null as any),[['window','scroll']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:scroll' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onWindowScroll($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_MediaDetectorComponent_0,RenderType_MediaDetectorComponent)),i1.ɵdid(1,
      114688,(null as any),0,i2.MediaDetectorComponent,[i3.Store,i4.AppUiActions,i5.DOCUMENT,
          'windowObject',i6.UtilityService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const MediaDetectorComponentNgFactory:i1.ComponentFactory<i2.MediaDetectorComponent> = i1.ɵccf('nw-media-detector',
    i2.MediaDetectorComponent,View_MediaDetectorComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9zcmMvbWFpbi9hbmd1bGFyL2FwcC9tZWRpYS1kZXRlY3Rvci9tZWRpYS1kZXRlY3Rvci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9qZW5raW5zL3dvcmtzcGFjZS9uZXctd2F2ZS0tbnctYWRlc2EtdWktcGlwZWxpbmUvc291cmNlL3NyYy9tYWluL2FuZ3VsYXIvYXBwL21lZGlhLWRldGVjdG9yL21lZGlhLWRldGVjdG9yLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9zcmMvbWFpbi9hbmd1bGFyL2FwcC9tZWRpYS1kZXRlY3Rvci9tZWRpYS1kZXRlY3Rvci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9zcmMvbWFpbi9hbmd1bGFyL2FwcC9tZWRpYS1kZXRlY3Rvci9tZWRpYS1kZXRlY3Rvci5jb21wb25lbnQudHMuTWVkaWFEZXRlY3RvckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxzcGFuIGNsYXNzPVwibWVkaWEtZGV0ZWN0b3JcIiAod2luZG93OnJlc2l6ZSk9XCJvblJlc2l6ZSgpXCIgI2RldGVjdG9yPjwvc3Bhbj5cbiIsIjxudy1tZWRpYS1kZXRlY3Rvcj48L253LW1lZGlhLWRldGVjdG9yPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7c0RDQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUE2QjtNQUFBO01BQUE7SUFBQTtJQUE3QjtFQUFBLGdDQUEyRTs7OztvQkNBM0U7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLDJFQUFBO01BQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/main/angular/$$_gendir/app/media-detector/media-detector.component.ngfactory.ts